module.exports = __webpack_public_path__ + "media/img/careers/why-work/why-work-img2-3176fab7fac0ba9cdd1c2971e309b9e0.svg";